<!-- 会员列表页面 -->
<template>
		<div class="bg-fff">
			<formQuery :queryOpts="queryOpts" @query="searchCallback"></formQuery>
			<!-- 按钮区域 -->
			<div class="rx-bc mb16">
				<el-button type="primary" @click="()=>{creatEvent()}">新增岗位</el-button>
			</div>
			<!-- 数据表格 -->
			<div class="">
				<el-table :data="tableData.list" stripe style="width: 100%" @selection-change="selectionChange">
					<!-- <el-table-column type="selection" width="55" /> -->
					<el-table-column label="岗位名称" min-width="120" show-overflow-tooltip>
						<template #default="scope">
							<span class="color-409EFF c_p tool_btn" @click="creatEvent(scope.row.encryptionId)">{{scope.row.roleName}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="num" label="岗位人数" min-width="120"></el-table-column>
					<el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip></el-table-column>
					<el-table-column label="操作" width="120">
						<template #default="scope">
							<a href="javascript:;" class="t_d_u v_a_m color-409EFF tool_btn" @click="roleEvent(scope.row.encryptionId)">权限</a>
							<a href="javascript:;" class="t_d_u v_a_m color-409EFF tool_btn" @click="stopEvnet(scope.row)">删除</a>
						</template>
					</el-table-column>
					<template #empty>
						<el-empty description="暂无数据"></el-empty>
					</template>
				</el-table>
				<div class="mt20 rx-ec" v-show="tableData.list.length > 0">
					<el-pagination v-model:currentPage="tableData.form.page" :page-sizes="[15,20,30,50,100]"
						:page-size="tableData.form.limit" layout="total, sizes, prev, pager, next, jumper"
						:total="tableData.count" @size-change="pageSizeChange" @current-change="()=>{getList()}">
					</el-pagination>
				</div>
			</div>
			<!-- 新增、编辑岗位 -->
			<el-dialog v-model="createData.show" :title="createData.title" width="500px" custom-class="popwechat"
				:before-close="()=>{createData.show = false}" :append-to-body="true">
				<div class="pl20 pt20 pb20 pr60">
					<div class="rx-sc mb12">
						<span class="w110 t_a_r">岗位名称：</span>
						<div class="flex1">
							<el-input v-model="createData.form.roleName" type="text" placeholder="请输入"></el-input>
						</div>
					</div>
					<div class="rx-ss mb12">
						<span class="w110 t_a_r">备注：</span>
						<div class="flex1">
							<el-input v-model="createData.form.remark" :rows="5" maxlength="100" type="textarea"
								show-word-limit placeholder="请输入备注" />
						</div>
					</div>
				</div>
				<template #footer>
					<div class="dialog-footer">
						<el-button @click="createData.show = false">取消</el-button>
						<el-button type="primary" @click="createSave">确定</el-button>
					</div>
				</template>
			</el-dialog>
			<!-- 权限 -->
			<el-dialog v-model="roleData.show" title="权限设置" width="500px" custom-class="popwechat"
				:before-close="()=>{roleData.show = false}" :append-to-body="true">
				<div class="pl20 pt20 pb20 pr60">
					<el-tree
						ref="tree"
					  	:data="roleData.data"
					  	show-checkbox
					  	node-key="id"
					  	default-expand-all
						:props="{label:'menuName', id: id, children: children}"
					  	:default-checked-keys="roleData.list"
					  >
					</el-tree>
				</div>
				<template #footer>
					<div class="dialog-footer">
						<el-button @click="roleData.show = false">取消</el-button>
						<el-button type="primary" @click="roleSave">确定</el-button>
					</div>
				</template>
			</el-dialog>
			<Confirm ref="confirmRef" :title="confirm.confirmTitle" :text="confirm.confirmText" @save="confirmSave" />
		</div>
</template>

<script setup>
	import { ref, reactive, onMounted, nextTick } from 'vue';
	import { useRouter, onBeforeRouteLeave } from 'vue-router';
	import { ElMessage } from 'element-plus'
	import { ArrowDown, Close, Upload, ArrowUp} from '@element-plus/icons-vue'
	import utils from '@/common/utils.js'
	import { getAdminRoleList, insertAdminRole, getAdminRoleOne, updateAdminRole, delAdminRole, adminRoleAuthToEdit, adminRoleAuthEdit } from '@/api/store.js';
	import formQuery from '@/components/branch-store/formQuery.vue';
	import Confirm from '@/components/Confirm.vue'
	const tree = ref()
	const router = useRouter();
	const queryOpts = reactive({
		fields: [{
			type: 'input',
			fieldName: 'roleName',
			placehold: '输入岗位名称'
		}]
	})
	var selectCheckData = [],
		confirmType = '',
		storeId = '';
	const confirm = reactive({
		confirmTitle:'',
		confirmText:'',
	}) 
	const confirmRef = ref();
	//新增分店
	const createData = reactive({
		form: {
			encryptionId:'',
			roleName: '',
			remark: '',
		},
		title: '',
		show: false,
	})

	function creatEvent(id) {
		for (var k in createData.form) {
			createData.form[k] = '';
		}
		createData.title = id ? '修改岗位' :'新增岗位';
		createData.show = true;
		if(id){
			getPostDetail(id);
		}
	}
	function getPostDetail(id){
		getAdminRoleOne({
			encryptionId:id
		}).then((res) => {
			if (res.code == 0) {
				for (var k in createData.form) {
					createData.form[k] = res.data[k];
				}
			}
		})
	}
	// 新增、修改保存
	function createSave() {
		var {encryptionId} = createData.form;
		if(encryptionId){
			updateAdminRole(createData.form).then((res) => {
				if (res.code == 0) {
					createData.show = false;
					ajaxSaveCallBack('修改成功');
				}
			})
		}else{
			insertAdminRole(createData.form).then((res) => {
				if (res.code == 0) {
					createData.show = false;
					ajaxSaveCallBack('新增成功');
				}
			})
		}
	}
	/**
	 * 绑定权限
	 */
	function roleSave() {
		let arry = []
		tree.value.getCheckedNodes(false, true).forEach((item) => {
			arry.push(item.id)
		})
		if(arry.length == 0){
			ElMessage({
				type: 'warning',
				message: '请选择权限',
			})
			return false;
		}
		let params = {
			encryptionId: roleData.encryptionId,
			menu_ids: arry.join(',')
		}
		adminRoleAuthEdit(params).then(res => {
			if (res.code == 0) {
				ajaxSaveCallBack('设置成功');
				roleData.show = false
			}
		})
	}
	// 权限
	const roleData = reactive({
		show:false,
		encryptionId: '',
		list:[],
		data:[],
		defaultProps: {
		  children: 'children',
		  label: 'label'
		}
	})
	function roleEvent(id){
		roleData.encryptionId = id
		adminRoleAuthToEdit({ encryptionId: id }).then((res) => {
			if (res.code == 0) {
				roleData.data = res.data
				roleData.show = true;
				res.remark2.forEach((item) => {
					nextTick(() => {
						var node = tree.value.getNode(item)
						if(node.isLeaf){
						 	tree.value.setChecked(node, true);
						}
					})  
            	})
			}
		})
	}
	const tableData = reactive({
		list: [],
		count: 0,
		form: {
			page: 1,
			limit: 15,
			roleName: '',
		}
	})
	//筛选表单回调
	function searchCallback(options) {
		for (var key in options) {
			tableData.form[key] = options[key];
		}
		searchTable();
	}
	//切换分页数量
	function pageSizeChange(limit) {
		tableData.form.limit = limit;
		searchTable();
	}

	function searchTable() {
		tableData.form.page = 1;
		getList();
	}
	getList();

	function getList(exportObj) {
		var formData = JSON.parse(JSON.stringify(tableData.form));
		getAdminRoleList(formData).then(function(res) {
			if (res.code == 0) {
				tableData.list = res.data || [];
				tableData.count = res.count;
			}
		});
	}

	//停用
	function stopEvnet(row){
		storeId = row.encryptionId;
		confirmType = 'stop';
		confirm.confirmTitle = '确定要删除 '+row.roleName+' 吗？';
		confirmRef.value.show();
	}
	
	

	//通用确认框确认事件回调
	function confirmSave(){
		if(confirmType == 'stop'){
			delAdminRole({
				encryptionId:storeId,
				status:0
			}).then((res)=>{
				if(res.code == 0){
					ajaxSaveCallBack('删除成功');
				}
			})
		}
	}

	//table通用勾选
	function selectionChange(data) {
		selectCheckData = data;
	}
	//获取table勾选集合的某个字段集合
	function getSelectCheckKey(key) {
		return selectCheckData.map(n => n[key]).join(',');
	}
	// 验证批量操作是否勾选了数据
	function CheckLengthCallBack(callback) {
		if (selectCheckData.length == 0) {
			ElMessage({
				type: 'warning',
				message: '请选择需要操作的会员',
			})
			return false;
		}
		callback && callback();
	}
	//ajax提交保存通用提示
	function ajaxSaveCallBack(text, callback) {
		ElMessage({
			type: 'success',
			message: text
		})
		searchTable();
		callback && callback();
	}
	
	
	
	// 页面缓存
	onBeforeRouteLeave((to, from) => {
		// if (to.path === '/branch/memberDetail') {
		//     store.commit('SetKeep',{keepLiveRoute : ['BranchMemberList']});
		// } else {
		//     store.commit('SetKeep',{keepLiveRoute : []});
		// }
	})
</script>
<style scoped lang="stylus">
	
</style>
